import {required} from "vuelidate/lib/validators";

export class QuestionGroup {
    constructor(initObjectParams) {
        this.id = null;
        this.name = null;
        this.listOrder = 0;
    }

    static get modelName() {
        return 'QuestionGroup'
    }

    static get validations() {
        return {
            name: { required },
            listOrder: { required },
        }
    }

    static get validationFieldLabels() {
        return {
            name: 'Название',
            listOrder: 'Порядок',
        }
    }

    static get mapping() {
        return {
            listOrder: 'list_order'
        }
    }

    static get label() {
        return 'Тематика'
    }

    static get newLabel() {
        return 'Новая тематика'
    }

    label() {
        return 'Тематика'
    }

    objectLabel() {
        return `${this.name}`
    }

    applyData(data) {
        this.id = data['id'];
        this.name = data['name'];
        this.listOrder = data['list_order']
    }

}